define(['angular'], function(angular) {


    function AuthProvider() {
        let bdcUrl;

        /**
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                let self = {};

                /**
                 * Create or update a contract
                 * @return {Promise}
                 */
                self.getAuthUrl = function() {
                    return $http.get(bdcUrl + 'auth/google').then(url => {
                        return url;
                    });
                };

                self.loginHelpline = function() {
                    return $http.get(bdcUrl + 'auth/helpline').then(url => {
                        return url;
                    });
                };

                return self;
            }
        ];
    }

    angular.module('app.portal.authProvider', []).provider('auth', AuthProvider);
});
